import { render, staticRenderFns } from "./NoticeDetailForm.vue?vue&type=template&id=1fac5812&scoped=true&"
import script from "./NoticeDetailForm.vue?vue&type=script&lang=js&"
export * from "./NoticeDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./NoticeDetailForm.vue?vue&type=style&index=0&id=1fac5812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fac5812",
  null
  
)

export default component.exports